import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { DataShareServiceService } from '../data-share-service.service';

@Injectable({
  providedIn: 'root',
})
export class ApiHandlerService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    private dataService: DataShareServiceService
  ) {}

  /**
   * Helper to create headers for fetchData
   * @param isFormData - Whether the request body is FormData
   * @returns HeadersInit - Headers object
   */
  private createHeaders(isFormData: boolean): HeadersInit {
    const jwtToken = localStorage.getItem('token');
    return {
      Authorization: `Bearer ${jwtToken}`,
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    };
  }

  /**
   * Centralized method to make API requests using fetch API
   * @param endpoint - The API endpoint (relative URL)
   * @param method - The HTTP method (GET, POST, etc.)
   * @param body - Optional body for POST, PUT, etc.
   * @param isFormData - Whether the request body is FormData
   * @param retryAttempt - Internal retry attempt counter
   * @param includeApiPrefix - Whether to include 'api' in the URL (default: true)
   * @returns Observable<any>
   */
  fetchData(
    endpoint: string,
    method: string = 'GET',
    body?: any,
    isFormData: boolean = false,
    retryAttempt: number = 0,
    includeApiPrefix: boolean = true
  ): Observable<any> {
    const apiPrefix = includeApiPrefix ? '/api' : '';
    const url = `${this.baseUrl}${apiPrefix}${endpoint}`;
    // console.log(url, 'url');
    const headers: HeadersInit = this.createHeaders(isFormData);

    const requestOptions: RequestInit = {
      method,
      headers: new Headers(headers),
      body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
    };

    return new Observable((observer) => {
      fetch(url, requestOptions)
        .then(async (response) => {
          if (!response.ok) {
            // Create a custom error object that includes the status code
            const errorData = await response.json();
            throw {
              status: response.status,
              message: errorData.message || 'Unknown error',
            };
          }

          // Handle 204 No Content before trying to parse JSON
          if (response.status === 204) {
            return null;
          }

          return response.json();
        })
        .then((data) => {
          observer.next(data);
          observer.complete();
        })
        .catch((error) => {
          // If it's a 401 error and we haven't retried yet, attempt to refresh the token
          if (error.status === 401 && retryAttempt === 0) {
            const refreshToken = localStorage.getItem('refreshToken');
            
            if (!refreshToken) {
              this.handleSessionExpired();
              observer.error(error);
              return;
            }
            
            // Try to refresh the token
            this.renewAccessToken(refreshToken).subscribe({
              next: (response) => {
                if (response && response.accessToken) {
                  // Save the new token
                  localStorage.setItem('token', response.accessToken);
                  
                  // Retry the original request with the new token
                  this.fetchData(endpoint, method, body, isFormData, 1, includeApiPrefix).subscribe({
                    next: (data) => {
                      observer.next(data);
                      observer.complete();
                    },
                    error: (retryError) => {
                      observer.error(retryError);
                    }
                  });
                } else {
                  this.handleSessionExpired();
                  observer.error(error);
                }
              },
              error: () => {
                this.handleSessionExpired();
                observer.error(error);
              }
            });
          } else if (error.status === 401 || error.status === 403) {
            // If we already tried refreshing or it's a 403, handle session expiration
            this.handleSessionExpired();
            observer.error(error);
          } else {
            // For other errors, just pass them through
            observer.error(error);
          }
        });
    }).pipe(catchError(this.handleError));
  }

  //  fetchData2(
  //   endpoint: string,
  //   method: string = 'GET',
  //   body?: any,
  //   isFormData: boolean = false,
  //   retryAttempt: number = 0
  // ): Observable<any> {
  //   const url = `${environment.pdfServiceUrl}${endpoint}`;    // console.log(url, 'url');
  //   const headers: HeadersInit = this.createHeaders(isFormData);

  //   const requestOptions: RequestInit = {
  //     method,
  //     headers: new Headers(headers),
  //     body: body ? (isFormData ? body : JSON.stringify(body)) : undefined,
  //   };

  //   return new Observable((observer) => {
  //     fetch(url, requestOptions)
  //       .then(async (response) => {
  //         if (!response.ok) {
  //           // Create a custom error object that includes the status code
  //           const errorData = await response.json();
  //           throw {
  //             status: response.status,
  //             message: errorData.message || 'Unknown error',
  //           };
  //         }

  //         // Handle 204 No Content before trying to parse JSON
  //         if (response.status === 204) {
  //           return null;
  //         }

  //         return response.json();
  //       })
  //       .then((data) => {
  //         observer.next(data);
  //         observer.complete();
  //       })
  //       .catch((error) => {
  //         // If it's a 401 error and we haven't retried yet, attempt to refresh the token
  //         if (error.status === 401 && retryAttempt === 0) {
  //           const refreshToken = localStorage.getItem('refreshToken');
            
  //           if (!refreshToken) {
  //             this.handleSessionExpired();
  //             observer.error(error);
  //             return;
  //           }
            
  //           // Try to refresh the token
  //           this.renewAccessToken(refreshToken).subscribe({
  //             next: (response) => {
  //               if (response && response.accessToken) {
  //                 // Save the new token
  //                 localStorage.setItem('token', response.accessToken);
                  
  //                 // Retry the original request with the new token
  //                 this.fetchData(url, method, body, isFormData, 1).subscribe({
  //                   next: (data) => {
  //                     observer.next(data);
  //                     observer.complete();
  //                   },
  //                   error: (retryError) => {
  //                     observer.error(retryError);
  //                   }
  //                 });
  //               } else {
  //                 this.handleSessionExpired();
  //                 observer.error(error);
  //               }
  //             },
  //             error: () => {
  //               this.handleSessionExpired();
  //               observer.error(error);
  //             }
  //           });
  //         } else if (error.status === 401 || error.status === 403) {
  //           // If we already tried refreshing or it's a 403, handle session expiration
  //           this.handleSessionExpired();
  //           observer.error(error);
  //         } else {
  //           // For other errors, just pass them through
  //           observer.error(error);
  //         }
  //       });
  //   }).pipe(catchError(this.handleError));
  // }

  private handleSessionExpired(): void {
    console.log('Session expired or unauthorized access');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userData');
    this.dataService.clearUserData();
    this.router.navigate(['/login']);
  }

  renewAccessToken(refreshToken: string): Observable<any> {
    const url = `${this.baseUrl}/api/authX/v1/auth/refresh`;
    const payload = { refreshToken: refreshToken };

    return new Observable((observer) => {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error('Failed to refresh token');
          }
          return response.json();
        })
        .then((data) => {
          observer.next(data);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }

  /** This function is not getting used anywhere in codebase */
  postData(
    endpoint: string,
    payload: any,
    headersObj: { [header: string]: string } = {},
    includeApiPrefix: boolean = true
  ): Observable<any> {
    const apiPrefix = includeApiPrefix ? '/api' : '';
    const url = `${this.baseUrl}${apiPrefix}${endpoint}`;
    const jwtToken = localStorage.getItem('token');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwtToken}`,
      ...headersObj,
    });

    return this.http
      .post<any>(url, payload, { headers })
      .pipe(catchError(this.handleError));
  }

  /**
   * Centralized error handling for both fetch and HttpClient
   * @param error - Error object
   * @returns Observable<never>
   */
  private handleError(error: any): Observable<never> {
    console.error('An error occurred:', error.message || error);
    return throwError(
      () => new Error(error.message)
    );
  }

  /**
   * Helper to format error messages
   * @param error - Error object
   * @returns string - Formatted error message
   */
  private formatError(error: any): string {
    return error.message
      ? `${error.message}`
      : 'An unknown error occurred.';
  }

  /* These are the API calls that are part of shared components */
  getPedagogy(
    tree_id: any,
    _class?: string,
    subject_no?: number
  ): Observable<any> {
    let url = `/content/v1/skill_trees?tree_id=${tree_id}`;
    if (_class) {
      url += `&class=${_class}`;
    }
    if (subject_no) {
      url += `&subject_no=${subject_no}`;
    }
    return this.fetchData(url);
  }

  getContent(contentId: string, version?: number, languageCode?: string): Observable<any> {
    let url = `/content/v1/items/${contentId}`;
    if (version) {
      url += `/versions/${version}`;
    }
    const lang = languageCode?.trim();
    if (lang) {
      const sep = url.includes('?') ? '&' : '?';
      url += `${sep}language_code=${encodeURIComponent(lang)}`;
    }
    return this.fetchData(url);
  }

  getContentInLanguages(contentId: string, languages: string): Observable<any> {
    return this.fetchData(`/content/v1/items/${contentId}?languages=${languages}`);
  }

  getContainer(container_id: string): Observable<any> {
    return this.fetchData(`/content/v1/container/${container_id}/info`);
  }

  getContainerContents(container_id: string): Observable<any>{
    return this.fetchData(`content/v1/container/${container_id}/contents`)
  }

  getTransitions(workflowId: number): Observable<any> {
    return this.fetchData(`/content/v1/workflow/${workflowId}`);
  }

  uploadMedia(data: FormData): Observable<any> {
    return this.fetchData('/content/v1/media/upload', 'POST', data, true);
  }

  searchMedia(searchCriteria: string, type: string): Observable<any> {
    const criteria = encodeURIComponent(
      JSON.stringify({
        search_text: searchCriteria,
        type: type,
      })
    );

    return this.fetchData(
      `/content/v1/media/upload/search?criteria=${criteria}`
    );
  }

  searchContainers(passageIds: string): Observable<any> {
    const passageId = passageIds
      .split(',')
      .map((passageId) => `"${passageId.trim()}"`)
      .join(', ');
    return this.fetchData(
      `/content/v1/container/search?criteria={"type":["PassageGroup"], "item_ids":[${passageId}]}&fields=container_id,container_name,status_id,container_ids`
    );
  }

  updateMedia(data: FormData, mediaType:string, mediaId:number): Observable<any> {
    return this.fetchData(`/content/v1/media/upload/${mediaType}/${mediaId}`, 'PUT', data, true);
  }


  uploadMediaV2(data: FormData, parentMediaId?: number): Observable<any> {
    const endpoint = parentMediaId
      ? `/content/v2/media/upload?parent_media_id=${parentMediaId}`
      : '/content/v2/media/upload';
    return this.fetchData(endpoint, 'POST', data, true);
  }

  /**
   * V3 upload — targets `image_files_new`. Multipart: `file` (required), optional
   * `description`, `tags`, `language_code`, `colored`, `parent_media_ids` (JSON array string), `image_texts` (JSON string), `task_id`.
   */
  uploadMediaV3(
    data: FormData,
    options?: { parentMediaId?: number; languageCode?: string; taskId?: number }
  ): Observable<any> {
    const parentId = options?.parentMediaId;
    if (parentId != null && parentId > 0 && !data.has('parent_media_ids')) {
      data.append('parent_media_ids', JSON.stringify([parentId]));
    }
    const uploadTaskId = options?.taskId;
    if (uploadTaskId != null && uploadTaskId > 0 && !data.has('task_id')) {
      data.append('task_id', String(uploadTaskId));
    }
    const lang = options?.languageCode?.trim();
    if (lang && !data.has('language_code')) {
      data.append('language_code', lang);
    }

    return this.fetchData('/content/v3/media/upload', 'POST', data, true);
  }

  /**
   * v2 structured search for media buckets (image/video/audio).
   * Backend expects `criteria` as a JSON string with at least `{ type: "image" | "video" | "audio" }`.
   */
  searchMediaV2(params: {
    criteria: any;
    page?: number;
    pageSize?: number;
    fields?: string[];
  }): Observable<any> {
    const criteriaStr = encodeURIComponent(JSON.stringify(params.criteria));
    const page = params.page ?? 1;
    const pageSize = params.pageSize ?? 20;

    let url = `/content/v2/search/media?criteria=${criteriaStr}&page=${page}&pageSize=${pageSize}`;
    if (params.fields && params.fields.length) {
      url += `&fields=${encodeURIComponent(params.fields.join(','))}`;
    }

    return this.fetchData(url);
  }

  /**
   * Update `image_files_new.status_id` and related `image_tasks` row (allotted_to, languages, etc.).
   * Endpoint: PUT /content/v2/media/upload/:media_id/status/:task_id
   * Body: `{ "status_id": number }` only.
   */
  updateMediaTaskStatusV2(params: {
    mediaId: number;
    taskId: number;
    statusId: number;
  }): Observable<any> {
    const endpoint = `/content/v2/media/upload/${params.mediaId}/status/${params.taskId}`;
    const body = { status_id: params.statusId };

    return this.fetchData(endpoint, 'PUT', body, false);
  }

}
